<mat-card appearance="raised" class="anon-form--container mat-elevation-z12">
  <div class="anon-form--header dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".anon-form--container" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
    <h5 class="anon-form--title">{{ sysText.anonymousNewRequest.anonymousNewRequest_title | titlecase }}</h5>
    <p class="body2 anon-form--subtitle">{{ sysText.anonymousNewRequest.anonymousNewRequest_subtitle }}</p>
  </div>
  <mat-card-content>
    <form [formGroup]="form" class="anon-form--form">
      <div class="new-employee">
        <div class="ee-row">
          <div class="ee-row-left">
            <app-input-field
              [icon]="'person'"
              [label]="sysText.anonymousNewRequest.submitNewRequest_firstName"
              [control]="form.controls.firstName"
              [group]="form"
              [autocomplete]="'given-name'">
            </app-input-field>
          </div>
          <div class="ee-row-right">
            <app-input-field
              [hideIconSpace]="!(isMobile$ | async)"
              [label]="sysText.anonymousNewRequest.submitNewRequest_middleName"
              [control]="form.controls.middleName"
              [group]="form"
              [autocomplete]="'additional-name'">
            </app-input-field>
          </div>
        </div>
        <div class="ee-row">
          <div class="ee-row-left">
            <app-input-field
              [label]="sysText.anonymousNewRequest.submitNewRequest_lastName"
              [control]="form.controls.lastName"
              [group]="form"
              [autocomplete]="'family-name'">
            </app-input-field>
          </div>
          <div class="ee-row-right">
            <app-input-field
              [hideIconSpace]="!(isMobile$ | async)"
              [label]="sysText.anonymousNewRequest.submitNewRequest_suffix"
              [control]="form.controls.suffix"
              [group]="form"
              [autocomplete]="'honorific-suffix'">
            </app-input-field>
          </div>
        </div>
        <div class="new-ee-full-column">
          <app-input-field
            [group]="form"
            [control]="form.controls.company"
            [icon]="'business'"
            [label]="sysText.anonymousNewRequest.submitNewRequest_company"
            [inputType]="'string'"
            [autocomplete]="'organization'">
          </app-input-field>
        </div>
        <app-email-field-group
          [group]="form"
          [workEmailControl]="form.controls.workEmail"
          [isWorkEmailPreferredControl]="form.controls.isWorkEmailPreferred"
          [personalEmailControl]="form.controls.personalEmail"
          [isPersonalEmailPreferredControl]="form.controls.isPersonalEmailPreferred"
          [autocomplete]="'email'">
        </app-email-field-group>
        <div class="new-ee-full-column">
          <app-input-field
            [icon]="'phone'"
            [label]="sysText.anonymousNewRequest.submitNewRequest_workPhone"
            [control]="form.controls.workPhone"
            [group]="form"
            [autocomplete]="'work tel'">
          </app-input-field>
        </div>
        <div class="new-ee-full-column">
          <app-input-field
            [label]="sysText.anonymousNewRequest.submitNewRequest_personalPhone"
            [control]="form.controls.personalPhone"
            [group]="form"
            [autocomplete]="'home tel'">
          </app-input-field>
        </div>
      </div>

      <div class="date-fields">
        <div class="date-fields-column-left">
          <app-date-field
            [label]="sysText.anonymousNewRequest.submitNewRequest_startDate"
            [control]="form.controls.startDate"
            [group]="form"
            [icon]="'date_range'"
            (emitDateChange)="updateEndDate()">
          </app-date-field>
        </div>
        <div class="date-fields-column left-margin">
          <app-date-field
            [label]="sysText.anonymousNewRequest.submitNewRequest_endDate"
            [control]="form.controls.endDate"
            [hideIconSpace]="!(isMobile$ | async)"
            [group]="form">
          </app-date-field>
        </div>
      </div>
      <app-select-field
        [group]="form"
        [control]="form.controls.leaveReasonId"
        [options]="anonymousRequestInfo.leaveReasonOptions"
        [icon]="'live_help'"
        [label]="sysText.anonymousNewRequest.submitNewRequest_leaveReason"
        [shouldCapitalize]="false">
      </app-select-field>
      <app-text-area
        [group]="form"
        [control]="form.controls.comments"
        [icon]="'comment'"
        [label]="sysText.anonymousNewRequest.submitNewRequest_comments">
      </app-text-area>
      <div class="section-header-container">
        <h2 class="overline grey1 semibold section-title">{{sysText.anonymousNewRequest.submitNewRequest_documents | uppercase}}</h2>
        <mat-divider class="section-header-underline"></mat-divider>
      </div>
      <input hidden type="file" #imgFileInput (change)="handleFileInput($event.target.files)" autocomplete="off"/>
      <div class="file-input-field">
        <mat-icon class="input-icon">attach_file</mat-icon>
        <button
          #uploadButton
          type="button"
          mat-stroked-button
          color="accent"
          (click)="imgFileInput.click()"
          class="button">
          <mat-icon>upload</mat-icon>
          <span>{{sysText.anonymousNewRequest.submitNewRequest_upload | capitalizefirst}}</span>
        </button>
      </div>
      @if (fileToUpload) {
        <div class="pad">
          <div class="flex-horiz bot-space">
            <mat-icon class="fill4-dk">check</mat-icon>
            <div>
              <span class="body2 side-space grey3">{{ fileToUpload?.name }}</span>
            </div>
            <button type="button" class="button-reset" [attr.aria-label]="sysText.anonymousNewRequest.removeFile_ariaLabel" (click)="clearFile()">
              <mat-icon class="black-inactive small pointer">clear</mat-icon>
            </button>
          </div>
        </div>
      }
      <app-input-field
        [group]="form"
        [control]="form.controls.documentTitle"
        [icon]="'description'"
        [label]="sysText.anonymousNewRequest.submitNewRequest_documentTitle">
      </app-input-field>
      <app-select-field
        [group]="form"
        [control]="form.controls.documentCategoryId"
        [options]="anonymousRequestInfo.documentCategoryOptions"
        [icon]="'list'"
        [label]="sysText.anonymousNewRequest.submitNewRequest_documentCategory"
        [shouldCapitalize]="false"
        [showBlankOption]="true">
      </app-select-field>
      <app-text-area
        [group]="form"
        [control]="form.controls.documentComments"
        [label]="sysText.anonymousNewRequest.submitNewRequest_docComments"
        [icon]="'comment'">
      </app-text-area>
    </form>

    <!-- submit keeps focus while sending: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    @let isSubmitting = isSubmitting$ | async;
    <button
      mat-flat-button
      color="accent"
      class="button submit--button"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? sysText.anonymousNewRequest.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ sysText.anonymousNewRequest.submitRequest }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>

    <div class="anon-form--link caption">
      <a [routerLink]="'/' + accountRoutePaths.LOGIN">
        {{ sysText.anonymousNewRequest.backToLogin | capitalizefirst }}
      </a>
    </div>
  </mat-card-content>

  <ng-template #loadingTemplate>
    <div class="spinner-container">
      <mat-spinner color="accent" diameter="40"></mat-spinner>
    </div>
  </ng-template>
</mat-card>
